// extracted by mini-css-extract-plugin
module.exports = {"formulario":"searchbar_formulario__3yTM5"};